/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, ChangeDetectionStrategy} from '@angular/core';
import {ClaimProgressStepModel} from './claim-progress-step.model';

@Component({
    selector: 'app-claim-progress-step',
    templateUrl: './claim-progress-step.component.html',
    styleUrls: ['../../../styles/base.component.css', './claim-progress-step.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClaimProgressStepComponent {
    @Input() model: ClaimProgressStepModel;
    @Input() titlePosition: 'top' | 'bottom' = 'top';
    @Input() isStart = false;
    @Input() isFinalStep = false;
    @Input() isFinalStepColumn = false;
    @Input() tooltipToggle = new EventEmitter<boolean>();

    public delegateTooltipToggle(show: boolean): void {
        if (this.isFinalStep) {
            this.tooltipToggle.emit(show);
        }
    }
}
